module.exports = __webpack_public_path__ + "img/coin.ef574c6b.png";